import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=407bb711&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=407bb711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407bb711",
  null
  
)

export default component.exports